"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

require("./style.scss");
/**
* Pill for a Card Component.
*/


var CardPill = function CardPill(_a) {
  var style = _a.style,
      text = _a.text;
  return react_1.default.createElement("div", {
    className: "story-card__pill",
    style: style
  }, text);
};

CardPill.propTypes = {
  /** Styling object of the `Card` */
  // eslint-disable-next-line react/forbid-prop-types
  style: prop_types_1.default.object,

  /** Text to fill the `CardPill` */
  text: prop_types_1.default.string.isRequired
};
CardPill.defaultProps = {
  style: undefined
};
exports.default = CardPill;